/*
@file-overview 

- These methods were brought over from AEM WCAX repos

- NOTE : These methods are not being used in the library currently

*/
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DatalayerService {

  constructor() { }

  public setError(id, feature, message) {
    window['AB']['DATALAYER'].setError(id, feature, message);
  }

  public getDataLayer() {
    return window['AB'] && window['AB']['DATALAYER'];
  }

  public removeItemFromCart(product? : any, searchTerm? : any) {
    window['AB']['DATALAYER'].removeItemFromCart(product, searchTerm);
  }

  public addItemToCart(product? : any, searchTerm? : any) {
    window['AB']['DATALAYER'].addItemToCart(product, searchTerm);
  }

  public increaseItemQuantity(product? : any, searchTerm? : any) {
    window['AB']['DATALAYER'].increaseItemQuantity(product, searchTerm);
  }

  public decreaseItemQuantity(product? : any, searchTerm? : any) {
    window['AB']['DATALAYER'].decreaseItemQuantity(product, searchTerm);
  }
  
  public updateCartId(cartId) {
    window['AB']['DATALAYER'].updateCartId(cartId);
  }

  public updateCart(allItems, newItem, wyswygFlag? : any) {
    window['AB']['DATALAYER'].updateCart(allItems, newItem, wyswygFlag);
  }

  public updateCartSummary(cartSummary) {
    window['AB'].CART.updateCartSummary(cartSummary);
  }

  public recommendationInfo(recommendation) {
    window['AB']['DATALAYER'].recommendationInfo(recommendation);
  }
  
  public productInfo(product) {
    window['AB']['DATALAYER'].productInfo(product);
  }
  
  public setCarouselName(carouselName) {
    window['AB']['DATALAYER'].setCarouselName(carouselName);
  }
  
  public isRecipesPage() {
    return window['AB']['DATALAYER'].isRecipesPage();
  }
  
  public clipCoupon(coupon, analyticsData) {
    window['AB']['DATALAYER'].clipCoupon(coupon, analyticsData);
  }

  public unClipCoupon(coupon) {
    window['AB']['DATALAYER'].unClipCoupon(coupon);
  }

  public setLinkClickOfferDrawer(linkClicked, offerName) {
    window['AB']['DATALAYER'].setLinkClickOfferDrawer(linkClicked, offerName);
  }

  public setLinkClickEvents(linkClicked) {
    window['AB']['DATALAYER'].setLinkClickEvents(linkClicked);
  }

  public setModalClickEvents(modalClicked, modalMessage?, oncePerPage?) {
    window['AB']['DATALAYER'].setModalClickEvents(modalClicked, modalMessage, oncePerPage);
  }

  public getDrawerStatus(productID) {
    return window['AB']['DATALAYER'].getDrawerStatus(productID);
  }

  public setPastPurchasedImpressions(product) {
    window['AB']['DATALAYER'].setPastPurchasedImpressions('aisles');
  }

  public updateCartSavings(total, clipped, response? : any) {
    window['AB'].DATALAYER.updateCartSavings(total, clipped, response);
  }

  public updateSearch(searchTerm, numOfResults) {
    window['AB']['DATALAYER'].updateSearch(searchTerm, numOfResults);
  }

  public setModalClickEventsSubstitution(modalAction, substitutionObj, substitutionItems, product?) {
    if ( substitutionObj ) {
      substitutionObj.productID = window.sessionStorage.getItem('analytics_subs_prodId') || '';
    }

    if (window['AB'] && window['AB']['DATALAYER']) {
      window['AB']['DATALAYER'].setModalClickEventsSubstitution(modalAction, substitutionObj, substitutionItems, product);
    }
  }

  public setSnsLinkClick(snsOffer) {
    window['AB'].DATALAYER.setSnsLinkClick(snsOffer);
  }

  public setAnalyticsCrossPageData(action: string, name: string, data: any, isAcrossPages?: boolean) {
    if (window['AB'] && window['AB'].DATALAYER) {
      window['AB'].DATALAYER.setAnalyticsCrossPageData({ action: action, name: name, data: data, isAcrossPages: isAcrossPages });
    }
  }

  public setModalClickSubstitutionAllItems(action: string, substitutionObj: any) {
    if (window['AB'] && window['AB'].DATALAYER && window['AB'].DATALAYER.setModalClickSubstitutionAllItems) {
      window['AB'].DATALAYER.setModalClickSubstitutionAllItems(action, substitutionObj);
    }
  }
}

